<template>
  <pt-balance-detail class="pt-balance-detail__page"></pt-balance-detail>
</template>

<script>
import PtBalanceDetail from 'cps//new-to-old-audit/pt-balance-manage/pt-balance-detail/withData'
export default {
  name: 'pt-balance-detail__view',
  components: {
    'pt-balance-detail': PtBalanceDetail
  }
}
</script>
